module.exports = __webpack_public_path__ + "static/media/bg_top_navbar.6e767e9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/bg/bg_top_navbar.jpg
// module id = 317
// module chunks = 0